<div class="paragraph-holder bp-margin-bottom-double">
  <h3 [innerHTML]="text"></h3>
  <h4 *ngIf="subtitle" [innerHTML]="subtitle"></h4>
</div>
